/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import styles from "./ContentWrapper.module.scss";
import classnames from "classnames";

interface Props {
    children: JSX.Element | Array<JSX.Element>;
    className?: string;
}

const ContentWrapper: React.FC<Props> = ({children, className}) => {
    return (
        <div className={classnames(styles.contentWrapper, className)}>
            {children}
        </div>
    )
}

export default ContentWrapper;